// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogIndexPage_title__341hM","articlesList":"BlogIndexPage_articlesList__1V39R","footer":"BlogIndexPage_footer__1vkZQ"};